module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTg2Ljg3IDE4LjVjLTExLjM4IDAtMzEuMjEtMi44My0zNi44OC04LjUtNS42NyA1LjY3LTI1LjUgOC41LTM2Ljg4IDguNWwuMDkuMDNDMTMuMDkgMTkuNjQgOC4wMyA3Mi41NyA1MC4wNCA5NWM0Mi40NS0yMi42NyAzNi44My03Ni41IDM2LjgzLTc2LjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_shield.svg
// module id = j3sZ
// module chunks = 1